import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../../components/Elements/customTittle/customTittle';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import "./getContract.css"




 
const GetContract = (props) => {

 
    

    return <> 
    <div 
    onClick={() => {
        props.showContract(false)
        let elems0;
        elems0 = document.getElementById(props.elementID)
       
        let elems = elems0.querySelectorAll('div.partPdf');
        let elemsIMG = elems0.querySelectorAll('div.partPdfImg')
        var imgWidth = 190;
        var pageHeight = 290;
        var position = 10;
        var doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        
        
        if(elemsIMG.length != 0){
        elemsIMG.forEach((elem, idx) => {
          
            elem.style.width="964"
            elem.style.height="fit-content"
            elem.style.display="fix"
            elems0.style.display="block"
        
          
            html2canvas(elem, { scale: '1.5' }).then((canvas) => {
                
                var divData = canvas.toDataURL('image/png');
                var divHeight = (canvas.height * imgWidth) / canvas.width;
          
                if (idx < elems.length - 1) {
                    
                    if (pageHeight > position + divHeight) {
                        doc.addImage(
                            divData,
                            'PNG',
                            10,
                            position,
                            imgWidth,
                            divHeight
                        )
                        setTimeout(1000, 'Timeout adding page #' + idx);
                        position += divHeight;
                    } else {
                        
                        doc.addPage();
                        position = 10;
                        doc.addImage(
                            divData,
                            'PNG',
                            10,
                            position,
                            imgWidth,
                            divHeight
                        );
                        setTimeout(1000, 'Timeout adding page #' + idx);
                        position += divHeight;
                    }
                } else {
                    if (pageHeight > position + divHeight) {
                        doc.addImage(
                            divData,
                            'PNG',
                            10,
                            position,
                            imgWidth,
                            divHeight
                        );
                        setTimeout(1000, 'Timeout adding page #' + idx);
                        position += divHeight;
                    } else {
                        doc.addPage();
                        position = 10;
                      
                        doc.addImage(
                            divData,
                            'PNG',
                            10,
                            position,
                            imgWidth,
                            divHeight
                        );
                        setTimeout(1000, 'Timeout adding page #' + idx);
                        position += divHeight;
                    }
                    doc.save(props.titlePDF + '.pdf');
                }
                elems.forEach((elem, idx) => {
          
                    elem.style.width="964"
                    elem.style.height="fit-content"
                    elems0.style.display="block"
                    html2canvas(elem, { scale: '1.5' }).then((canvas) => {
                        var divData = canvas.toDataURL('image/png');
                        var divHeight = (canvas.height * imgWidth) / canvas.width;
                        if (idx < elems.length - 1) {
                            
                            if (pageHeight > position + divHeight) {
                                doc.addImage(
                                    divData,
                                    'PNG',
                                    10,
                                    position,
                                    imgWidth,
                                    divHeight
                                );
                                setTimeout(1000, 'Timeout adding page #' + idx);
                                position += divHeight;
                            } else {
                                
                                doc.addPage();
                                position = 10;
                                doc.addImage(
                                    divData,
                                    'PNG',
                                    10,
                                    position,
                                    imgWidth,
                                    divHeight
                                );
                                setTimeout(1000, 'Timeout adding page #' + idx);
                                position += divHeight;
                            }
                        } else {
                            if (pageHeight > position + divHeight) {
                                doc.addImage(
                                    divData,
                                    'PNG',
                                    10,
                                    position,
                                    imgWidth,
                                    divHeight
                                );
                                setTimeout(1000, 'Timeout adding page #' + idx);
                                position += divHeight;
                            } else {
                                doc.addPage();
                                position = 10;
                              
                                doc.addImage(
                                    divData,
                                    'PNG',
                                    10,
                                    position,
                                    imgWidth,
                                    divHeight
                                );
                                setTimeout(1000, 'Timeout adding page #' + idx);
                                position += divHeight;
                            }
                            doc.save(props.titlePDF + '.pdf');
                        }
                    });
                    elems0.style.display="none"
                });
            });
            elems0.style.display="none"
        })}else{
            
            elems.forEach((elem, idx) => {
          
                elem.style.width="964"
                elem.style.height="fit-content"
                elems0.style.display="block"
                html2canvas(elem, { scale: '1.5' }).then((canvas) => {
                    var divData = canvas.toDataURL('image/png');
                    var divHeight = (canvas.height * imgWidth) / canvas.width;
                    if (idx < elems.length - 1) {
                        
                        if (pageHeight > position + divHeight) {
                            doc.addImage(
                                divData,
                                'PNG',
                                10,
                                position,
                                imgWidth,
                                divHeight
                            );
                            setTimeout(1000, 'Timeout adding page #' + idx);
                            position += divHeight;
                        } else {
                            
                            doc.addPage();
                            position = 10;
                            doc.addImage(
                                divData,
                                'PNG',
                                10,
                                position,
                                imgWidth,
                                divHeight
                            );
                            setTimeout(1000, 'Timeout adding page #' + idx);
                            position += divHeight;
                        }
                    } else {
                        if (pageHeight > position + divHeight) {
                            doc.addImage(
                                divData,
                                'PNG',
                                10,
                                position,
                                imgWidth,
                                divHeight
                            );
                            setTimeout(1000, 'Timeout adding page #' + idx);
                            position += divHeight;
                        } else {
                            doc.addPage();
                            position = 10;
                          
                            doc.addImage(
                                divData,
                                'PNG',
                                10,
                                position,
                                imgWidth,
                                divHeight
                            );
                            setTimeout(1000, 'Timeout adding page #' + idx);
                            position += divHeight;
                        }
                        doc.save(props.titlePDF + '.pdf');
                    }
                });
                elems0.style.display="none"
            });
        }


      
        props.showContract(true)
    }}
    className='getContract'>
        <svg width="19" height="20" viewBox="0 0 19 20" className='iconDownload' fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0371 13.0415C16.772 13.042 16.5179 13.1533 16.3305 13.3512C16.143 13.549 16.0375 13.8173 16.0371 14.0971V16.6304C16.0366 16.7982 15.9733 16.9591 15.8609 17.0778C15.7485 17.1964 15.5961 17.2633 15.4371 17.2637H2.6371C2.4781 17.2633 2.32573 17.1964 2.2133 17.0778C2.10086 16.9591 2.03755 16.7982 2.03711 16.6304V14.0971C2.03711 13.72 1.84648 13.3715 1.53711 13.183C1.22773 12.9944 0.846484 12.9944 0.537108 13.183C0.227733 13.3715 0.0371094 13.72 0.0371094 14.0971V16.6304C0.0379844 17.358 0.312165 18.0555 0.79954 18.5701C1.28698 19.0845 1.94779 19.374 2.63714 19.3749H15.4371C16.1264 19.374 16.7872 19.0845 17.2747 18.5701C17.7621 18.0556 18.0363 17.358 18.0371 16.6304V14.0971C18.0367 13.8173 17.9312 13.549 17.7438 13.3512C17.5563 13.1533 17.3022 13.042 17.0371 13.0415H17.0371Z" fill="#CC0033"/>
            <path d="M9.03755 0.375492C8.77249 0.375953 8.51837 0.487314 8.33093 0.685166C8.14349 0.883019 8.03798 1.15126 8.03755 1.43105V10.9994L4.87756 8.22037C4.67375 8.04151 4.41106 7.9553 4.14706 7.98056C3.88313 8.0059 3.63943 8.14074 3.46956 8.35548C3.30012 8.57061 3.21844 8.84789 3.24238 9.12656C3.26638 9.40515 3.39413 9.66239 3.59756 9.8417L8.39755 14.0639C8.44792 14.1016 8.50149 14.1344 8.55755 14.1619C8.59411 14.1877 8.63236 14.2109 8.67192 14.2311C8.90498 14.3347 9.16773 14.3347 9.40074 14.2311C9.43936 14.2108 9.4768 14.1879 9.51274 14.1627C9.5688 14.1352 9.6223 14.1024 9.67274 14.0648L14.4727 9.84255C14.6844 9.65671 14.8141 9.38694 14.8313 9.09694C14.8485 8.80686 14.7517 8.5222 14.5636 8.30996C14.3755 8.09773 14.1129 7.97674 13.8375 7.97547C13.6037 7.97594 13.3774 8.06256 13.1975 8.22036L10.0376 10.9994V1.43104C10.0371 1.15126 9.93162 0.883015 9.74418 0.685162C9.55674 0.487309 9.3026 0.375948 9.03755 0.375492Z" fill="#CC0033"/>
        </svg>

    <p>{props.titlePDF}.pdf</p>
    </div>
    </>;
    }

export default GetContract;
